/**
 * Formats a start and end time to display on the front end
 * @param {number} startTime - Timestamp of the start time
 * @param {number} endTime - Timestamp of the end time
 * @returns {string}
 */
export function getFormattedDate(startTime, endTime = null) {

    let dateString = '';

    // set our formatting options
    const options = {
        year: "numeric",
        month: "short",
        day: "numeric",
        timeZone: "America/Los_Angeles"
    };

    // create our date formatter instance
    const dateTimeFormat = new Intl.DateTimeFormat('en', options);

    // get start and end date, convert unix time stamp to milliseconds
    let startDate = new Date(startTime * 1000);
    if(endTime){
        let endDate = new Date(endTime * 1000);
        // return a formatted string date range
         dateString = dateTimeFormat.formatRange(startDate, endDate);
    } else {
        // return a formatted string date range
        dateString = dateTimeFormat.format(startDate);
    }
    

    return (
        dateString
    );
}